export interface ClientProcedureAttachment {
  id: string;
  fileName: string;
  contentType?: string | null;
  size: number;
  uploadedByName?: string | null;
  /** Mostrado como imagem no texto; a lista de anexos não repete. */
  inline?: boolean;
  createdDate: string;
}

export interface ClientProcedure {
  id: string;
  commercialClientId?: string | null;
  /** Procedimento geral: unidade 1-4 (mesmo enum de Company). */
  unitType?: number | null;
  title: string;
  /** HTML já sanitizado pelo backend. */
  contentHtml?: string | null;
  order: number;
  updatedByName?: string | null;
  updatedDate?: string | null;
  createdDate: string;
  attachments: ClientProcedureAttachment[];
}

export interface SaveClientProcedure {
  commercialClientId?: string | null;
  unitType?: number | null;
  title: string;
  contentHtml?: string | null;
  /** UpdatedDate carregado na tela; o servidor recusa se outra pessoa salvou no meio. */
  expectedUpdatedDate?: string | null;
  /** Imagens enviadas nesta edição; as que não ficaram no texto o servidor exclui. */
  discardAttachmentIds?: string[];
}

/** Campos da ficha editáveis na Intranet. */
export interface IntranetClientFields {
  modality?: string | null;
  particularities?: string | null;
  followUpFrequency?: string | null;
  carrier?: string | null;
  services?: string | null;
  operationalEmails?: string | null;
  analyst?: string | null;
  dispatcher?: string | null;
  segment?: string | null;
  radar?: string | null;
  contract?: string | null;
  dossierNumber?: string | null;
  insuranceEndorsement?: string | null;
  internationalFreight?: string | null;
  marginText?: string | null;
  financialCost?: string | null;
}

export const MAX_ATTACHMENT_BYTES = 25 * 1024 * 1024;

export interface IntranetImportCandidate {
  commercialClientId: string;
  name: string;
  companyType?: number | null;
  /** 0-100; 100 = mesmo nome normalizado. */
  score: number;
}

export interface IntranetImportPreviewFicha {
  key: string;
  name: string;
  unit?: number | null;
  procedures: number;
  files: number;
  alreadyImported: number;
  candidates: IntranetImportCandidate[];
}

export interface IntranetImportPreview {
  fichas: IntranetImportPreviewFicha[];
  generalCount: number;
  generalAlreadyImported: number;
  fileCount: number;
  totalBytes: number;
}

export interface IntranetImportResult {
  success: boolean;
  notifications: string[];
  clientsUpdated: number;
  clientsCreated: string[];
  fichasSkipped: number;
  proceduresCreated: number;
  proceduresSkipped: number;
  filesSaved: number;
}
